export enum ConstructionStatusAPIResponse {
  PreNTP = 'preNTP',
  IncentiveAllocation = 'incentiveAllocation',
  IXCostApproved = 'ixCostApproved',
  NTP = 'ntp',
  ConstructionStart = 'constructionStart',
  MechanicallyComplete = 'mechanicallyComplete',
  ConstructionComplete = 'constructionComplete',
  FinalComplete = 'finalComplete',
}
